import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions, Statistic, TipType } from './index';
import { PaginatedResponse, PaginationProps } from '../types';

export type StatisticListData = PaginatedResponse<Statistic>;

export type StatisticListResponse = StatisticListData;

export type StatisticListParams = PaginationProps & {
  categoryId?: string;
  subCategoryId: string;
  group?: string;
  tipType: TipType;
}

export const statisticList = (payload: StatisticListParams): Action<StatisticListParams> => ({
  type: actions.statisticListTrigger.toString(),
  payload,
});

export const statisticListClear = (): Action => ({
  type: actions.statisticListClear.toString(),
});

export const statisticListErrorClear = (): Action => ({
  type: actions.statisticListErrorReset.toString(),
});

export function* statisticListRequestSaga({ payload }: Action<StatisticListParams>) {
  yield put({
    type: actions.statisticListStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.statisticListError.toString(),
      payload: {
        message: 'StatisticList: Parameters not passed.',
      },
    });

    return;
  }

  const response = (yield call(
    fetchAuthSaga,
    `${config.api.url}statistics?${new URLSearchParams(payload).toString()}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<StatisticListData, StatisticListResponse>(
    response,
    actions.statisticListSuccess.toString(),
    actions.statisticListError.toString(),
    false,
    (statisticListData) => statisticListData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.statisticListTrigger.toString(),
    defaultProcessingSaga(
      statisticListRequestSaga,
      {
        error: actions.statisticListError.toString(),
        locationCancel: actions.statisticListClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.statisticListSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.statisticListError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.statisticListErrorReset.toString(),
    });
  });
}
